<template>
  <footer class="text-center prose dark:prose-invert lg:prose-xl">
    © 2024-2026 John P. Pennock. 
    <span class="hidden lg:inline-block lg:mr-2">See</span>
    <NuxtLink to="/license">License</NuxtLink>
    <span class="hidden lg:inline-block lg:ml-2">for details.</span>
  </footer>
</template>